import { render, staticRenderFns } from "./index_new.vue?vue&type=template&id=57b98452&scoped=true"
import script from "./index_new.vue?vue&type=script&lang=js"
export * from "./index_new.vue?vue&type=script&lang=js"
import style0 from "./index_new.vue?vue&type=style&index=0&id=57b98452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b98452",
  null
  
)

export default component.exports